<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <tickets-table></tickets-table>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
  import TicketsTable from './TicketsTable.vue'

  export default {
    name: 'lottery-tickets',
    components: {TicketsTable}
  }
</script>



// WEBPACK FOOTER //
// src/views/lottery/tickets/Tickets.vue